import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { I18nProvider } from "./context/I18nContext";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DashboardHome from "./pages/DashboardHome";
import WhatsApp from "./pages/WhatsApp";
import Templates from "./pages/Templates";
import History from "./pages/History";
import Users from "./pages/Users";
import Connections from "./pages/Connections";
import MetaConnections from "./pages/MetaConnections";
import MetaInbox from "./pages/MetaInbox";
import MetaPublish from "./pages/MetaPublish";
import MetaInsights from "./pages/MetaInsights";
import Settings from "./pages/Settings";
import DataDeletion from "./pages/DataDeletion";
import DataDeletionRequest from "./pages/DataDeletionRequest";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import About from "./pages/About";
import Contact from "./pages/Contact";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-whatsapp"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <I18nProvider>
      <SettingsProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/privacidade" element={<PrivacyPolicy />} />
              <Route path="/termos" element={<TermsOfUse />} />
              <Route path="/sobre" element={<About />} />
              <Route path="/contato" element={<Contact />} />
              <Route path="/exclusao-de-dados" element={<DataDeletionRequest />} />
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }>
                <Route index element={<DashboardHome />} />
                <Route path="whatsapp" element={<WhatsApp />} />
                <Route path="templates" element={<Templates />} />
                <Route path="history" element={<History />} />
                <Route path="users" element={<Users />} />
                <Route path="connections" element={<Connections />} />
                <Route path="meta-connections" element={<MetaConnections />} />
                <Route path="inbox" element={<MetaInbox />} />
              <Route path="publish" element={<MetaPublish />} />
              <Route path="insights" element={<MetaInsights />} />
                <Route path="settings" element={<Settings />} />
                <Route path="data-deletion" element={<DataDeletion />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </SettingsProvider>
    </I18nProvider>
  );
}

export default App;
